import { FC, useState } from "react";

import { Button, DropdownPortal, Icon } from "common/components";
import { DropdownItem } from "common/components/base/Dropdown";
import { ButtonVariant } from "common/enums";
import useCustomTranslation from "common/hooks/useCustomTranslation";

import { IMAGE_COLLECTION } from "assets/media";
import { ClientOptions } from "modules/home/enums/create-engagement/create-engagement.enum";
import labelCollection from "../../config/langauge-keys.config";

import "./ClientMoreOptions.scss";

type ClientMoreOptionsProps = {
  clientData: any;
  isDisabled?: boolean;
  hideEditClientBtn?: boolean;
  onOptionClick: (option: ClientOptions, data: any) => void;
};

const ClientMoreOptions: FC<ClientMoreOptionsProps> = ({
  clientData,
  isDisabled,
  hideEditClientBtn = false,
  onOptionClick
}: ClientMoreOptionsProps) => {
  const { t } = useCustomTranslation(["common", "home"]);

  const [showMoreOptions, setShowMoreOptions] = useState<boolean>(false);

  const moreOptionsTrigger = (
    <Button
      variant={ButtonVariant.SECONDARY}
      onClick={() => setShowMoreOptions((prevState) => !prevState)}
      className="more-options-btn"
      disabled={isDisabled}
      icon={IMAGE_COLLECTION.IC_VERT_ELLIPSIS}
    ></Button>
  );

  const handleOptionClick = (action: ClientOptions, data: any) => {
    onOptionClick?.(action, data);
    setShowMoreOptions(false);
  };

  return (
    <DropdownPortal
      portalClassName="client-options-v2"
      open={showMoreOptions}
      trigger={moreOptionsTrigger}
      handleClickOutside={() => setShowMoreOptions(false)}
    >
      {!hideEditClientBtn ? (
        <DropdownItem
          onClick={() => handleOptionClick(ClientOptions.EDIT, clientData)}
          disabled={isDisabled}
        >
          <Icon src={IMAGE_COLLECTION.IC_EDIT_FOR_OPTIONS} />
          {t(labelCollection.editClientTitle)}
        </DropdownItem>
      ) : (
        <></>
      )}

      <DropdownItem
        onClick={() =>
          handleOptionClick(ClientOptions.DOWNLOAD_FEEDBACK, clientData)
        }
        disabled={isDisabled}
      >
        <Icon src={IMAGE_COLLECTION.IC_DOWNLOAD_ICON} />
        {t(labelCollection.downloadFeedback)}
      </DropdownItem>
    </DropdownPortal>
  );
};

export default ClientMoreOptions;
